import {
  CLEAR_AUTOCOMPLETE_SONGS,
  RECEIVE_AUTOCOMPLETE_SONGS,
  REQUEST_AUTOCOMPLETE_SONGS,
} from '../action_constants'
import { defaultFilters, defaultPagination } from '../api/songs'
import { SORT_OPTIONS } from '../components/filters'

const defaultState = {
  isFetching: false,
  filters: defaultFilters,
  pagination: defaultPagination,
  searchTerm: '',
  sortBy: SORT_OPTIONS.RELEVANCE,
  suggestions: [],
}

export default function autocompleteSongs(state = defaultState, action) {
  switch (action.type) {
    case REQUEST_AUTOCOMPLETE_SONGS:
      return {
        ...state,
        isFetching: true,
        filters: action.filters,
        searchTerm: action.searchTerm,
        sortBy: action.sortBy,
      }
    case RECEIVE_AUTOCOMPLETE_SONGS:
      return {
        ...state,
        isFetching: false,
        suggestions: action.suggestions,
        filters: action.filters,
        searchTerm: action.searchTerm,
        sortBy: action.sortBy,
      }
    case CLEAR_AUTOCOMPLETE_SONGS:
      return {
        ...state,
        suggestions: [],
        isFetching: false,
        searchTerm: '',
      }
    default:
      return state
  }
}
